import { Drawer, Typography } from '@material-ui/core';
import React, { FC, ReactNode, useEffect } from 'react';
import useStyles from './styles';
import {
  useInsideDrawerState,
  useInsideDrawerActions,
  DrawerType,
  DrawerAlignment,
  DrawerTypeVariant,
} from '@src/shared/context/inside-drawer';
import { Trans } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import { trackNotificationIconClickCloseEvent } from '@src/shared/tracking/navigation';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { on } from 'events';

export interface IDrawerSettings {
  drawerVariant?: DrawerTypeVariant; //'permanent' | 'persistent' | 'temporary'; // Temporary is Modal View
  fullSize?: boolean;
  customClose?: boolean;
  anchor?: DrawerAlignment;
}

interface IInsideDrawerProps {
  children: ReactNode;
  titleI18nKey: string;
  type: DrawerType;
  settings: IDrawerSettings;
  onClose?: () => void;
}

export const InsideDrawer: FC<IInsideDrawerProps> = ({
  children,
  titleI18nKey,
  type,
  settings = {
    drawerVariant: 'persistent',
    fullSize: false,
    customClose: false,
    anchor: 'right',
  },
  onClose,
}) => {
  const { setDrawerFlush } = useInsideDrawerActions();
  const { activeDrawerState } = useInsideDrawerState();
  const classes = useStyles();
  const { isAndroid } = useDeviceDetect();

  useEffect(() => {
    return () => setDrawerFlush();
  }, []);

  return (
    <Drawer
      variant={settings.drawerVariant}
      anchor={settings.anchor}
      open={activeDrawerState === type}
      className={`${classes.insideDrawer}`}
      classes={{
        paper: settings.fullSize
          ? `${classes.insideDrawerPaperFull} ${isAndroid ? 'isAndroid' : ''}`
          : `${classes.insideDrawerPaper} ${isAndroid ? 'isAndroid' : ''}`,
      }}
      onClose={() => {
        onClose && onClose();
        window.requestAnimationFrame(() => {
          document.body.style.overflow = '';
        });
      }}
    >
      {settings.customClose ? null : (
        <div className={classes.notificationDrawerCTA}>
          <CloseIcon
            onClick={() => {
              if (activeDrawerState === DrawerType.NOTIFICATION) {
                trackNotificationIconClickCloseEvent('');
              }
              return setDrawerFlush(true);
            }}
            style={{ cursor: 'pointer', fontSize: '22px' }}
          />
          <Typography variant="h5" className="heading_s">
            <Trans i18nKey={titleI18nKey} />
          </Typography>
        </div>
      )}
      {children}
    </Drawer>
  );
};

export default InsideDrawer;
